module.exports = __webpack_public_path__ + "img/ic_social_facebook.757de479.svg";